import { useSelector } from "react-redux";

import { customStylesSelector } from "store/selectors/selectors";

const AutoSvg = (props) => {
  const customStyles = useSelector(customStylesSelector);
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
    width="100%" viewBox="0 0 243 230" enable-background="new 0 0 243 230" >
 <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
   d="
 M139.000000,231.000000 
   C92.666672,231.000000 46.833340,231.000000 1.000006,231.000000 
   C1.000004,154.333344 1.000004,77.666679 1.000002,1.000016 
   C81.999992,1.000011 162.999985,1.000011 243.999969,1.000005 
   C243.999985,77.666649 243.999985,154.333298 244.000000,230.999969 
   C209.166672,231.000000 174.333328,231.000000 139.000000,231.000000 
 M214.039948,101.969963 
   C214.039948,101.969963 214.112106,101.969963 214.013336,101.262726 
   C213.022400,100.473717 212.031479,99.684708 211.035934,98.965675 
   C211.035934,98.965675 211.105759,98.959160 210.808792,98.302399 
   C207.183365,96.930573 205.032913,94.494316 203.997086,90.598564 
   C203.174362,87.504219 201.344742,84.677589 199.684738,81.101791 
   C196.859024,74.032234 194.037735,66.960907 191.206375,59.893608 
   C188.307510,52.657829 179.403152,46.156689 171.732590,45.262417 
   C171.244797,45.177464 170.757050,45.018391 170.269226,45.018154 
   C140.515442,45.003849 110.761650,44.993435 81.007950,45.039066 
   C79.994148,45.040623 78.981224,45.617451 77.190994,45.989399 
   C68.576012,47.795231 62.360268,52.551094 58.988033,60.799530 
   C58.368832,62.314091 57.719612,63.818233 57.157887,65.354118 
   C54.406811,72.876175 51.680645,80.407341 48.294151,88.211006 
   C45.842999,91.993942 44.032406,96.188972 39.247578,98.070114 
   C37.515400,98.751106 36.497890,101.249931 34.702633,103.643585 
   C33.244156,109.296753 32.935120,114.691605 38.029835,119.662498 
   C39.020821,123.650940 40.762650,127.619965 40.866367,131.631348 
   C41.221451,145.364365 40.968361,159.112442 41.047688,172.854187 
   C41.056435,174.369553 41.712547,175.881149 41.980404,178.095444 
   C43.487511,180.778320 44.369503,184.271576 46.611862,186.001266 
   C55.477032,192.839539 68.797470,189.842178 71.927795,178.954330 
   C72.994293,175.244888 72.671989,171.136139 73.909706,167.029404 
   C104.864960,167.020203 135.820312,166.971130 166.775314,167.058365 
   C170.184891,167.067978 173.592285,167.858398 176.913681,169.124191 
   C176.552505,176.051483 178.495605,182.481262 183.749268,186.829437 
   C191.243698,193.032181 202.867661,190.042831 206.892914,181.050766 
   C208.484726,177.494812 208.885620,173.188751 208.941406,169.211792 
   C209.030899,162.833725 208.381989,156.445282 208.810272,149.633682 
   C208.874512,145.485245 208.835449,141.332016 209.028046,137.189545 
   C209.294312,131.462082 209.735062,125.742744 210.008041,120.017303 
   C210.008041,120.017303 210.006363,120.110367 210.636490,119.981339 
   C211.045715,119.630493 211.454926,119.279655 212.289169,118.358032 
   C216.306091,113.852417 217.236588,108.816940 214.978302,102.600510 
   C214.666367,102.366295 214.354446,102.132080 214.039948,101.969963 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M208.045135,150.061234 
   C208.381989,156.445282 209.030899,162.833725 208.941406,169.211792 
   C208.885620,173.188751 208.484726,177.494812 206.892914,181.050766 
   C202.867661,190.042831 191.243698,193.032181 183.749268,186.829437 
   C178.495605,182.481262 176.552505,176.051483 177.143616,168.409668 
   C175.917526,167.150375 174.462860,166.134308 173.005264,166.130127 
   C141.358276,166.039368 109.710945,166.043655 78.063850,166.110550 
   C76.369888,166.114120 74.677422,166.827103 72.984261,167.209854 
   C72.671989,171.136139 72.994293,175.244888 71.927795,178.954330 
   C68.797470,189.842178 55.477032,192.839539 46.611862,186.001266 
   C44.369503,184.271576 43.487511,180.778320 42.159912,177.262024 
   C42.240707,173.947449 42.061165,171.466446 42.056541,168.985107 
   C42.028748,154.073013 42.042072,139.160828 42.039165,124.248665 
   C42.038631,121.505569 42.157730,118.667397 38.120380,118.851715 
   C32.935120,114.691605 33.244156,109.296753 35.267979,103.253311 
   C37.643509,101.522949 39.280346,99.462997 41.296329,98.977539 
   C47.379673,97.512657 48.196194,92.846634 48.945679,87.935295 
   C51.680645,80.407341 54.406811,72.876175 57.157887,65.354118 
   C57.719612,63.818233 58.368832,62.314091 58.988033,60.799530 
   C62.360268,52.551094 68.576012,47.795231 78.048134,46.007843 
   C110.009590,46.023659 141.113907,46.021030 172.218216,46.018402 
   C179.403152,46.156689 188.307510,52.657829 191.206375,59.893608 
   C194.037735,66.960907 196.859024,74.032234 199.478333,81.616409 
   C200.245041,85.520393 201.334457,88.881615 202.163223,92.305923 
   C203.318451,97.079247 206.393875,99.068665 211.105759,98.959160 
   C211.105759,98.959160 211.035934,98.965675 210.881668,99.275864 
   C211.855637,100.380692 212.983871,101.175331 214.112106,101.969963 
   C214.112106,101.969963 214.039948,101.969963 213.883789,102.252243 
   C214.114487,102.762535 214.501343,102.990547 214.888214,103.218567 
   C217.236588,108.816940 216.306091,113.852417 211.739075,118.638260 
   C210.794785,119.315781 210.400574,119.713074 210.006363,120.110367 
   C210.006363,120.110367 210.008041,120.017303 209.625824,119.926331 
   C208.796005,121.159279 207.972260,122.480186 207.961670,123.807587 
   C207.891830,132.558014 207.997025,141.309860 208.045135,150.061234 
 M207.179031,111.496796 
   C209.146729,107.387047 206.839630,105.098183 203.316055,104.825630 
   C199.297394,104.514793 198.012833,102.266716 196.831604,99.132828 
   C192.498505,87.636726 188.096100,76.166107 183.628571,64.721519 
   C180.565659,56.875252 174.830887,53.133324 166.291458,53.170269 
   C138.801483,53.289185 111.310669,53.208603 83.820175,53.217777 
   C75.138687,53.220673 69.635216,56.840382 66.493500,64.801262 
   C61.983948,76.228157 57.525879,87.676392 53.182430,99.167145 
   C51.979950,102.348343 50.644951,104.604080 46.660915,104.866913 
   C45.046204,104.973450 42.800575,107.091446 42.305588,108.734947 
   C41.944820,109.932800 43.627003,112.712944 45.017639,113.286613 
   C48.902557,114.889191 49.428036,117.649170 49.406185,121.263397 
   C49.308483,137.423874 49.339310,153.585388 49.396877,169.746262 
   C49.404503,171.886871 49.470146,174.148590 50.144676,176.138733 
   C51.328709,179.632156 54.087738,181.700500 57.809986,181.234421 
   C61.631870,180.755859 64.148041,178.359177 64.452721,174.294189 
   C64.639091,171.807556 64.549667,169.299820 64.572609,166.801453 
   C64.634293,160.084915 65.666077,159.040985 72.498116,159.038727 
   C106.486366,159.027481 140.474609,159.033295 174.462860,159.033401 
   C185.605682,159.033432 185.605652,159.033829 185.642487,169.933517 
   C185.645294,170.766556 185.623642,171.600586 185.656601,172.432449 
   C185.870316,177.829102 188.772369,181.279449 193.149460,181.358597 
   C197.648071,181.439926 200.578232,177.802399 200.578995,172.076813 
   C200.581100,156.082367 200.800003,140.082596 200.433121,124.096405 
   C200.306122,118.562866 201.257507,114.357727 207.179031,111.496796 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M73.446983,167.119629 
   C74.677422,166.827103 76.369888,166.114120 78.063850,166.110550 
   C109.710945,166.043655 141.358276,166.039368 173.005264,166.130127 
   C174.462860,166.134308 175.917526,167.150375 177.187134,167.990921 
   C173.592285,167.858398 170.184891,167.067978 166.775314,167.058365 
   C135.820312,166.971130 104.864960,167.020203 73.446983,167.119629 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M171.975403,45.640411 
   C141.113907,46.021030 110.009590,46.023659 78.436584,45.976212 
   C78.981224,45.617451 79.994148,45.040623 81.007950,45.039066 
   C110.761650,44.993435 140.515442,45.003849 170.269226,45.018154 
   C170.757050,45.018391 171.244797,45.177464 171.975403,45.640411 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M38.075108,119.257111 
   C42.157730,118.667397 42.038631,121.505569 42.039165,124.248665 
   C42.042072,139.160828 42.028748,154.073013 42.056541,168.985107 
   C42.061165,171.466446 42.240707,173.947449 42.203918,176.911560 
   C41.712547,175.881149 41.056435,174.369553 41.047688,172.854187 
   C40.968361,159.112442 41.221451,145.364365 40.866367,131.631348 
   C40.762650,127.619965 39.020821,123.650940 38.075108,119.257111 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M210.957275,98.630783 
   C206.393875,99.068665 203.318451,97.079247 202.163223,92.305923 
   C201.334457,88.881615 200.245041,85.520393 199.617035,81.931564 
   C201.344742,84.677589 203.174362,87.504219 203.997086,90.598564 
   C205.032913,94.494316 207.183365,96.930573 210.957275,98.630783 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M48.619915,88.073151 
   C48.196194,92.846634 47.379673,97.512657 41.296329,98.977539 
   C39.280346,99.462997 37.643509,101.522949 35.493797,102.891159 
   C36.497890,101.249931 37.515400,98.751106 39.247578,98.070114 
   C44.032406,96.188972 45.842999,91.993942 48.619915,88.073151 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M208.427704,149.847458 
   C207.997025,141.309860 207.891830,132.558014 207.961670,123.807587 
   C207.972260,122.480186 208.796005,121.159279 209.672363,119.927643 
   C209.735062,125.742744 209.294312,131.462082 209.028046,137.189545 
   C208.835449,141.332016 208.874512,145.485245 208.427704,149.847458 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M214.062714,101.616348 
   C212.983871,101.175331 211.855637,100.380692 210.883972,99.240875 
   C212.031479,99.684708 213.022400,100.473717 214.062714,101.616348 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M210.321426,120.045853 
   C210.400574,119.713074 210.794785,119.315781 211.526566,118.923645 
   C211.454926,119.279655 211.045715,119.630493 210.321426,120.045853 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M214.933258,102.909531 
   C214.501343,102.990547 214.114487,102.762535 213.885071,102.216194 
   C214.354446,102.132080 214.666367,102.366295 214.933258,102.909531 
 z"/>
 <path fill="#F5F7FA" opacity="1.000000" stroke="none" 
   d="
 M206.925415,111.780037 
   C201.257507,114.357727 200.306122,118.562866 200.433121,124.096405 
   C200.800003,140.082596 200.581100,156.082367 200.578995,172.076813 
   C200.578232,177.802399 197.648071,181.439926 193.149460,181.358597 
   C188.772369,181.279449 185.870316,177.829102 185.656601,172.432449 
   C185.623642,171.600586 185.645294,170.766556 185.642487,169.933517 
   C185.605652,159.033829 185.605682,159.033432 174.462860,159.033401 
   C140.474609,159.033295 106.486366,159.027481 72.498116,159.038727 
   C65.666077,159.040985 64.634293,160.084915 64.572609,166.801453 
   C64.549667,169.299820 64.639091,171.807556 64.452721,174.294189 
   C64.148041,178.359177 61.631870,180.755859 57.809986,181.234421 
   C54.087738,181.700500 51.328709,179.632156 50.144676,176.138733 
   C49.470146,174.148590 49.404503,171.886871 49.396877,169.746262 
   C49.339310,153.585388 49.308483,137.423874 49.406185,121.263397 
   C49.428036,117.649170 48.902557,114.889191 45.017639,113.286613 
   C43.627003,112.712944 41.944820,109.932800 42.305588,108.734947 
   C42.800575,107.091446 45.046204,104.973450 46.660915,104.866913 
   C50.644951,104.604080 51.979950,102.348343 53.182430,99.167145 
   C57.525879,87.676392 61.983948,76.228157 66.493500,64.801262 
   C69.635216,56.840382 75.138687,53.220673 83.820175,53.217777 
   C111.310669,53.208603 138.801483,53.289185 166.291458,53.170269 
   C174.830887,53.133324 180.565659,56.875252 183.628571,64.721519 
   C188.096100,76.166107 192.498505,87.636726 196.831604,99.132828 
   C198.012833,102.266716 199.297394,104.514793 203.316055,104.825630 
   C206.839630,105.098183 209.146729,107.387047 206.925415,111.780037 
 M167.651459,113.554680 
   C167.013687,113.868149 166.375916,114.181618 165.125854,114.848610 
   C164.126297,115.422600 163.076141,115.924240 162.135315,116.582207 
   C155.553116,121.185478 153.642929,129.444733 157.547119,136.274551 
   C161.454742,143.110367 169.614502,145.720016 176.885239,142.317825 
   C182.511475,139.685181 185.447845,135.091248 185.476868,128.923935 
   C185.510437,121.793869 181.615616,117.232742 175.148026,114.051025 
   C174.432587,114.009689 173.717163,113.968353 172.169418,113.838120 
   C170.777863,113.859818 169.386322,113.881516 167.651459,113.554680 
 M183.625748,97.037071 
   C179.414948,86.565094 175.119400,76.125954 171.041916,65.602325 
   C169.717056,62.182968 167.698990,60.676537 163.963486,60.690224 
   C137.980103,60.785446 111.996063,60.782413 86.012634,60.693462 
   C82.293526,60.680729 80.292328,62.146168 78.967682,65.610939 
   C74.759705,76.617371 70.263618,87.513336 65.928215,98.471512 
   C63.674889,104.167015 64.967644,106.113358 71.096420,106.118225 
   C106.907318,106.146645 142.718262,106.147743 178.529144,106.119484 
   C185.185379,106.114235 186.510864,103.959160 183.625748,97.037071 
 M64.741226,130.108276 
   C65.152534,131.542282 65.451164,133.020630 65.994888,134.402527 
   C68.210556,140.033737 72.550522,143.195358 78.399132,143.752792 
   C84.490562,144.333389 89.460617,141.822250 92.644531,136.481491 
   C95.715614,131.329987 95.633354,126.032974 92.487839,120.914345 
   C89.168282,115.512489 82.445396,112.689049 76.603241,114.086433 
   C69.599159,115.761742 65.571320,120.912025 64.741226,130.108276 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M183.738373,97.421707 
   C186.510864,103.959160 185.185379,106.114235 178.529144,106.119484 
   C142.718262,106.147743 106.907318,106.146645 71.096420,106.118225 
   C64.967644,106.113358 63.674889,104.167015 65.928215,98.471512 
   C70.263618,87.513336 74.759705,76.617371 78.967682,65.610939 
   C80.292328,62.146168 82.293526,60.680729 86.012634,60.693462 
   C111.996063,60.782413 137.980103,60.785446 163.963486,60.690224 
   C167.698990,60.676537 169.717056,62.182968 171.041916,65.602325 
   C175.119400,76.125954 179.414948,86.565094 183.738373,97.421707 
 M133.499680,98.545403 
   C147.534912,98.545403 161.570129,98.545403 176.160858,98.545403 
   C172.229446,88.823921 168.882812,80.157242 165.140778,71.664787 
   C164.486084,70.178947 162.177490,68.487595 160.619171,68.474220 
   C136.977829,68.271370 113.334000,68.294876 89.691605,68.421600 
   C88.193207,68.429626 85.832802,69.346176 85.344612,70.475845 
   C81.480255,79.417992 77.973061,88.514496 73.963669,98.545372 
   C93.999382,98.545372 113.249527,98.545372 133.499680,98.545403 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M64.703369,129.729584 
   C65.571320,120.912025 69.599159,115.761742 76.603241,114.086433 
   C82.445396,112.689049 89.168282,115.512489 92.487839,120.914345 
   C95.633354,126.032974 95.715614,131.329987 92.644531,136.481491 
   C89.460617,141.822250 84.490562,144.333389 78.399132,143.752792 
   C72.550522,143.195358 68.210556,140.033737 65.994888,134.402527 
   C65.451164,133.020630 65.152534,131.542282 64.703369,129.729584 
 M78.760422,136.155457 
   C80.461517,135.677399 82.480583,135.624054 83.799980,134.636200 
   C86.903160,132.312805 88.056976,129.086090 85.953758,125.464874 
   C84.129906,122.324669 81.430054,120.337944 77.670280,121.895576 
   C73.823021,123.489456 71.831123,126.700554 73.258156,130.713196 
   C73.988815,132.767731 76.349281,134.242645 78.760422,136.155457 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M175.243744,114.545769 
   C181.615616,117.232742 185.510437,121.793869 185.476868,128.923935 
   C185.447845,135.091248 182.511475,139.685181 176.885239,142.317825 
   C169.614502,145.720016 161.454742,143.110367 157.547119,136.274551 
   C153.642929,129.444733 155.553116,121.185478 162.135315,116.582207 
   C163.076141,115.924240 164.126297,115.422600 165.730835,114.799240 
   C166.888794,114.467651 167.441772,114.185425 167.994766,113.903206 
   C169.386322,113.881516 170.777863,113.859818 172.795746,114.128342 
   C174.029312,114.460968 174.636520,114.503372 175.243744,114.545769 
 M165.336884,123.850365 
   C162.805969,127.616425 162.549759,131.338043 166.144287,134.504791 
   C169.250961,137.241760 172.696732,136.936859 175.463684,134.020859 
   C178.098709,131.243835 178.708572,127.943817 176.194626,124.563232 
   C173.441956,120.861664 170.611618,120.518669 165.336884,123.850365 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M175.195892,114.298401 
   C174.636520,114.503372 174.029312,114.460968 173.211914,114.172791 
   C173.717163,113.968353 174.432587,114.009689 175.195892,114.298401 
 z"/>
 <path fill={props.fill ?? customStyles.icons.fill} opacity="1.000000" stroke="none" 
   d="
 M167.823120,113.728943 
   C167.441772,114.185425 166.888794,114.467651 166.036972,114.622475 
   C166.375916,114.181618 167.013687,113.868149 167.823120,113.728943 
 z"/>
 <path fill="#F6F8FA" opacity="1.000000" stroke="none" 
   d="
 M132.999664,98.545387 
   C113.249527,98.545372 93.999382,98.545372 73.963669,98.545372 
   C77.973061,88.514496 81.480255,79.417992 85.344612,70.475845 
   C85.832802,69.346176 88.193207,68.429626 89.691605,68.421600 
   C113.334000,68.294876 136.977829,68.271370 160.619171,68.474220 
   C162.177490,68.487595 164.486084,70.178947 165.140778,71.664787 
   C168.882812,80.157242 172.229446,88.823921 176.160858,98.545403 
   C161.570129,98.545403 147.534912,98.545403 132.999664,98.545387 
 z"/>
 <path fill="#E4EAF2" opacity="1.000000" stroke="none" 
   d="
 M78.366791,136.067490 
   C76.349281,134.242645 73.988815,132.767731 73.258156,130.713196 
   C71.831123,126.700554 73.823021,123.489456 77.670280,121.895576 
   C81.430054,120.337944 84.129906,122.324669 85.953758,125.464874 
   C88.056976,129.086090 86.903160,132.312805 83.799980,134.636200 
   C82.480583,135.624054 80.461517,135.677399 78.366791,136.067490 
 z"/>
 <path fill="#E2E8F1" opacity="1.000000" stroke="none" 
   d="
 M165.615051,123.610352 
   C170.611618,120.518669 173.441956,120.861664 176.194626,124.563232 
   C178.708572,127.943817 178.098709,131.243835 175.463684,134.020859 
   C172.696732,136.936859 169.250961,137.241760 166.144287,134.504791 
   C162.549759,131.338043 162.805969,127.616425 165.615051,123.610352 
 z"/>
 </svg>
  );
};
export default AutoSvg;
